import {
  ExtraInfoForOrderModel,
  OrderModel,
  PatientModel,
  useGetExtraInfoForEditingOrderQuery,
  useGetOrderDetailWithPatientQuery
} from "graphql/generated";
import graphQLClient from "graphql/react-query";

export type DrConsultOrderDetail = OrderModel & {
  patientSnapshot: PatientModel;
  extraInfo: ExtraInfoForOrderModel;
};

export type UseOrderInfo = {
  loading: boolean;
  data: DrConsultOrderDetail | null;
  refetch: () => Promise<void>;
  refetchOrder: () => Promise<OrderModel>;
};

export const useOrderInfo = (orderId: string): UseOrderInfo => {
  const {
    data: res,
    isLoading,
    refetch: orderRefetch
  } = useGetOrderDetailWithPatientQuery(graphQLClient, {
    input: {
      orderId
    }
  });

  const {
    data: extraInfoRes,
    isLoading: extraInfoLoading,
    refetch: extraRefetch
  } = useGetExtraInfoForEditingOrderQuery(graphQLClient, {
    input: {
      orderId
    }
  });

  const refetch = async () => {
    await orderRefetch();
    await extraRefetch();
  };

  const refetchOrder = async () => {
    const { data } = await orderRefetch();
    return data?.getOrderDetailWithPatient?.order;
  };

  return {
    loading: isLoading || extraInfoLoading,
    data: isLoading
      ? null
      : {
          ...res?.getOrderDetailWithPatient?.order,
          // The affiliate coupon is surfaced at the TOP LEVEL of the query
          // (getOrderDetailWithPatient.affiliateCoupon), not on the nested `order`:
          // gqlg de-dupes the AffiliateCoupon type and skips re-expanding it on the
          // top-level `order` (the generated `order` type has no affiliateCoupon field
          // at all). Merge the top-level coupon onto the order object so
          // ProductSelector's affiliate-lock engages.
          affiliateCoupon: res?.getOrderDetailWithPatient?.affiliateCoupon,
          patientSnapshot: res?.getOrderDetailWithPatient?.patient,
          extraInfo: extraInfoRes?.getExtraInfoForEditingOrder as any
        },
    refetch,
    refetchOrder
  };
};
